<p>resume-eurobits works!</p>
